const activitiesData = [
	{
		tabTitle: 'Road Freight',
		subtitle: 'Trusted Local Transport Partner',
		title: 'Seamless Freight Solutions',
		img: '/assets/img/home-page/services/road-fereight.webp',
		content: `Road Freight Logistics serves clients with extensive industry knowledge, dedicated individuals, and advanced technologies. Vehicles are equipped with tracking systems and cellular phones, and trailers have tracking devices.
For local goods transport, Interlink Oceana is a top choice for many corporate and international enterprises. Our framework ensures smooth cargo transportation and delivery.`,
		buttonTitle: 'Learn More',
		buttonLink: '/about',
	},

	{
		tabTitle: 'Air Freight',
		subtitle: 'Reliable and Efficient Delivery',
		title: 'Global Air Freight',
		img: '/assets/img/home-page/services/air-freight.avif',
		content: `Interlink Oceana's fleet of Boeing and Airbus aircraft ensures reliable cargo transport in and out of Hong Kong and China. With 15 domestic and 10 global stations, we guarantee smooth delivery for corporate and international clients.Our global partnerships and skilled professionals enable efficient, worldwide consignment transfers. Long-term relationships with high-profile clients reflect the mutual growth we've achieved.`,
		buttonTitle: 'Get the Latest Research',
		buttonLink: '/about',
	},
	{
		tabTitle: 'Sea Freight',
		subtitle: 'Reliable, Sustainable Shipping Solutions',
		title: 'Efficient Global Port Services',
		img: '/assets/img/home-page/services/sea-freight.jpeg',
		content: `Interlink Oceana, headquartered in Hong Kong, provides feeder services covering ports across the Indian Sub-Continent, Southeast Asia, and beyond.

We ensure reliable schedules, strong connectivity with Main Line Operator sailings, and reasonable rates. Using durable 20- and 40-foot containers, we handle all transportation needs, including large-volume shipments, ensuring timely and safe delivery. While meeting high service standards, we remain committed to environmental protection.`,
		buttonTitle: 'Discover Our Technology',
		buttonLink: '/about',
	},
];

export default activitiesData;
